const GameTypeLabel = Object.freeze({
  promotion: 'Gamification_GamesPopUp_Game_Type_Promotion',
  gamification: 'Gamification_GamesPopUp_Game_Type_Gamification'
})

export { GameTypeLabel }



// WEBPACK FOOTER //
// ./src/modules/gamification/enum/GameTypeEnum.js